module.exports = __webpack_public_path__ + "media/img/pages/companies/ubp-359a539d9013ad1660adb85338eda203.png";